<div class="login-page">
  <div class="login-backdrop"></div>

  <div class="login-card">
    <div class="login-card-inner">
      <div class="login-header">
        <img
          src="../../assets/images/physioLife logo artwork-02.png"
          alt="Physio Life"
          class="login-logo"
          />
        <h1 class="login-title">Welcome back</h1>
        <p class="login-subtitle">Sign in to your account to continue</p>
      </div>

      <form class="login-form" ngForm>
        @if (loading) {
          <div class="login-loading">
            <div class="lds-ripple">
              <div></div>
              <div></div>
            </div>
            <span class="login-loading-text">Signing in...</span>
          </div>
        }

        <div class="form-group">
          <label for="username" class="form-label">Username</label>
          <input
            type="text"
            name="username"
            class="form-control"
            id="username"
            placeholder="Enter your username"
            required
            [(ngModel)]="email"
            [disabled]="loading"
            autocomplete="username"
            />
        </div>

        <div class="form-group">
          <label for="password" class="form-label">Password</label>
          <div class="password-wrapper">
            <input
              [type]="showPassword ? 'text' : 'password'"
              name="password"
              class="form-control"
              id="password"
              placeholder="Enter your password"
              required
              [(ngModel)]="password"
              [disabled]="loading"
              autocomplete="current-password"
              />
            <button
              type="button"
              class="password-toggle"
              (click)="showPassword = !showPassword"
              [attr.aria-label]="showPassword ? 'Hide password' : 'Show password'"
              tabindex="-1"
              >
              <span class="password-toggle-icon" [class.visible]="showPassword">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
              </span>
              <span class="password-toggle-icon" [class.visible]="!showPassword">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </span>
            </button>
          </div>
        </div>

        <div class="form-actions">
          <button
            type="button"
            class="btn-login"
            (click)="login()"
            [disabled]="loading"
            >
            Sign in
          </button>
          <button type="button" class="btn-forget" (click)="forget()">
            Forgot password?
          </button>
        </div>
      </form>

      @if (message) {
        <div class="alert-error" role="alert">
          {{ message }}
        </div>
      }
    </div>
  </div>
</div>
